import * as React from 'react';
import { WithSearch } from '@elastic/react-search-ui';
import { Config } from '../../../helper';
import GroupTable from './GroupTable';

// Table view mode. One provider queries every group's index at once; the shared result set is
// split into one table per configured group (by `groupBy`). Groups render in config order, so
// headings/order don't depend on what the data returns; an empty group shows a no-results note.
export default function TableSearchResult(props) {
  const {displayOptions} = props;
  const {groupBy = '', groups: configuredGroups = [], style = ''} = displayOptions || {};

  // No groups configured → fall back to a single implicit table over all results.
  const groups = configuredGroups.length > 0 ? configuredGroups : [{match: '', columns: []}];

  return (
    <WithSearch mapContextToProps={({results, wasSearched}) => ({results, wasSearched})}>
      {({results, wasSearched}) => {
        if (!wasSearched) return null;

        return (
          <div className='search-results nv-grouped-table search-results--table'>
            {groups.map((group, idx) => (
              <GroupTable
                key={group.htmlId || group.match || idx}
                group={group}
                results={results}
                groupBy={groupBy}
                tableClassName={style}/>
            ))}
          </div>
        );
      }}
    </WithSearch>
  );
}
